<div class="facet-button-bar">
  <ion-button
    [ngClass]="{
      'usf-fill-green-button': anyFacetSelected,
      'usf-outline-green-button': !anyFacetSelected,
      'ion-text-wrap': isMobile === true,
    }"
    class="all-filters-button"
    (click)="onAllFiltersPressed()"
  >
    <ion-text *ngIf="isMobile === false" class="all-filters-text">
      {{ 'i18n.search.allFilters' | translate }}
    </ion-text>
    <ion-icon name="filter-outline" size="medium"></ion-icon>
  </ion-button>
  <div class="facet-button-container">
    <ion-button
      *ngIf="!!usfDeliveredFacetValue"
      [ngClass]="{
        'usf-fill-green-button': usfDeliveredFacetValue.state === 'selected',
        'usf-fill-white-button': usfDeliveredFacetValue.state !== 'selected',
        'selected-facet-button':
          usfDeliveredFacetValue?.state === 'selected' && isMobile,
      }"
      expand="block"
      shape="default"
      class="facet-button"
      (click)="handleCheckboxSelection()"
    >
      <ion-text
        class="facet-text"
        [ngClass]="{
          'selected-facet-text':
            usfDeliveredFacetValue?.state === 'selected' && isMobile,
        }"
      >
        {{ usfDeliveredFacetValue.value }}
      </ion-text>
      <div class="facet-deselect-container">
        <ion-button
          class="facet-deselect-button"
          *ngIf="usfDeliveredFacetValue.state === 'selected'"
          fill="clear"
          expand="block"
        >
          <ion-icon
            name="close-outline"
            slot="icon-only"
            color="light"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-button>
  </div>
  <ng-container *ngTemplateOutlet="ListFacetButton"></ng-container>
  <ng-container *ngIf="!!ourExclusivesVM?.facet">
    <ng-container
      *ngTemplateOutlet="
        facetButton;
        context: {
          facet: ourExclusivesVM?.facet,
          facetDisplayMessage: ourExclusivesVM?.facetDisplayMessage,
        }
      "
    >
    </ng-container>
  </ng-container>
  <ng-container *ngFor="let facetButtonVM of facetButtonVms">
    <ng-container
      *ngTemplateOutlet="
        facetButton;
        context: {
          facet: facetButtonVM.facet,
          facetDisplayMessage: facetButtonVM.facetDisplayMessage,
        }
      "
    >
    </ng-container>
  </ng-container>
</div>

<ng-template
  #facetButton
  let-facet="facet"
  let-facetDisplayMessage="facetDisplayMessage"
>
  <div class="facet-button-container">
    <ion-button
      [ngClass]="{
        'usf-fill-green-button': facet?.state?.hasActiveValues,
        'usf-fill-white-button': !facet?.state?.hasActiveValues,
        'selected-facet-button': facet?.state?.hasActiveValues && isMobile,
      }"
      (click)="onFacetButtonPress(facet?.state?.facetId)"
      shape="default"
      class="facet-button"
    >
      <ion-text
        class="facet-text"
        [ngClass]="{
          'facet-text-width-small': facetDisplayMessage.length <= 8 && isMobile,
          'facet-text-width-medium':
            facetDisplayMessage.length > 8 &&
            facetDisplayMessage.length <= 12 &&
            isMobile,
          'facet-text-width-large': facetDisplayMessage.length > 12 && isMobile,
        }"
      >
        {{ facetDisplayMessage }}
      </ion-text>
      <div class="facet-deselect-container">
        <ion-button
          (click)="onCloseIconClick($event, facet)"
          *ngIf="facet?.state?.hasActiveValues"
          fill="clear"
          class="facet-deselect-button"
        >
          <ion-icon
            name="close-outline"
            slot="icon-only"
            color="light"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-button>
  </div>
</ng-template>

<ng-template #ListFacetButton>
  <div class="facet-button-container" *ngIf="!!listFacet">
    <ion-button
      [ngClass]="{
        'usf-fill-green-button': listFacet?.isValuesSelected,
        'usf-fill-white-button': !listFacet?.isValuesSelected,
        'selected-facet-button': listFacet?.isValuesSelected && isMobile,
      }"
      expand="block"
      shape="default"
      class="facet-button"
      (click)="onListFacetButtonPress()"
    >
      <ion-text
        class="facet-text"
        [ngClass]="{
          'selected-facet-text': listFacet?.isValuesSelected && isMobile,
        }"
      >
        {{ listFacet?.displayName }}
        {{
          listFacet?.countValuesSelected > 0
            ? '(' + listFacet?.countValuesSelected + ')'
            : ''
        }}
      </ion-text>
      <div class="facet-deselect-container">
        <ion-button
          class="facet-deselect-button"
          (click)="onCloseListFacet()"
          *ngIf="listFacet?.isValuesSelected"
          fill="clear"
          expand="block"
        >
          <ion-icon
            name="close-outline"
            slot="icon-only"
            color="light"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-button>
  </div>
</ng-template>
